import type { ReactNode } from 'react'

/**
 * One titled part of a settings form: what it is on the left, its controls on the right
 * (a two-column grid; `sm:col-span-2` for a full row), stacked on narrower screens.
 */
export function SettingsPart({
  title,
  about,
  children,
}: {
  title: string
  about: ReactNode
  children: ReactNode
}) {
  return (
    <section className="flex flex-col gap-x-8 gap-y-3 border-t border-border p-4 first:border-t-0 sm:p-6 xl:flex-row">
      <div className="xl:w-60 xl:shrink-0">
        <h3 className="font-semibold text-ink">{title}</h3>
        <p className="mt-0.5 text-sm text-muted">{about}</p>
      </div>
      <div className="grid min-w-0 flex-1 content-start gap-4 sm:grid-cols-2">{children}</div>
    </section>
  )
}
